import React from "react";

// Styled components
import { About, Description, Hide, Image } from "../styles";

// Framer motion
import { motion } from "framer-motion";

// Images
import home1 from "../img/home1.png";

// Animation
import { titleAnim, fade, photoAnim } from "../animation";
import Wave from "./Wave";

const AboutSection = () => {
  const download = (url) => {
    alert("Resume Downloading...Thank You !")
    url="https://drive.google.com/u/0/uc?id=1vZjXV6DhsIGsnt1g0Dl3rdod17oNf47o&export=download"
    const a = document.createElement('a')
    a.href = url
    a.download = url.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
  return (
    <About>
      <Description>
        <motion.div>
          <Hide>
            <motion.h2 variants={titleAnim}>Hi There !! I am Aryan</motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>
              I'm a <span>Web-Developer</span>
            </motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}></motion.h2>
          </Hide>
        </motion.div>
        <motion.p variants={fade}>
        Currently in 3rd year of BTech at Vellore Institue Of Technology, Also actively looking for internships in the field of Software Development.
        <br></br>
        5 ⭐ for C++ & Python on HackerRank | 3 ⭐ on LeetCode
        </motion.p>
        <motion.button variants={fade} onClick={download}>My Resume</motion.button>
      </Description>
      {/* <Image>
        <motion.img variants={photoAnim} src={home1} alt="Guy with a camera" />
      </Image> */}
      <Wave />
    </About>
  );
};

export default AboutSection;
